import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function PortfolioDetail() {
  const { t } = useTranslation();
  const { id } = useParams();

  const projectsData: Record<string, any> = {
    '1': {
      title: 'تطوير استراتيجية شركة تقنية',
      client: 'شركة التقنية المتقدمة',
      category: 'استشارات إدارية',
      duration: '6 أشهر',
      year: '2024',
      image: 'https://public.readdy.ai/ai/img_res/8ef5fa756d766d3f708ab77204b71937.jpg',
      challenge: 'كانت الشركة تواجه تحديات في النمو والتوسع في أسواق جديدة، مع الحاجة إلى تطوير استراتيجية واضحة للسنوات الخمس القادمة.',
      solution: 'قمنا بإجراء تحليل شامل للسوق والمنافسين، وعقدنا ورش عمل مع الإدارة العليا لتحديد الرؤية والأهداف الاستراتيجية. طورنا خطة تنفيذية مفصلة تشمل استراتيجيات التوسع والتطوير.',
      results: [
        { metric: 'زيادة الإيرادات', value: '45%', description: 'نمو في الإيرادات السنوية' },
        { metric: 'تحسين الكفاءة', value: '60%', description: 'تحسين في الكفاءة التشغيلية' },
        { metric: 'أسواق جديدة', value: '3', description: 'دخول أسواق جديدة بنجاح' },
        { metric: 'منتجات جديدة', value: '8', description: 'إطلاق منتجات وخدمات جديدة' }
      ],
      testimonial: {
        text: 'العمل مع فريق الأستاذ مصطفى محمد كان تجربة استثنائية. ساعدونا في رسم مستقبل واضح لشركتنا وتحقيق نمو غير مسبوق.',
        author: 'أحمد السعيد',
        position: 'الرئيس التنفيذي'
      },
      gallery: [
        'https://readdy.ai/api/search-image?query=business%20strategy%20planning%20session%20with%20charts%20and%20presentations%2C%20clean%20professional%20environment%2C%20corporate%20meeting%20room%2C%20high%20quality%20photography&width=600&height=400&seq=gallery1a&orientation=landscape',
        'https://readdy.ai/api/search-image?query=professional%20team%20collaboration%20working%20on%20business%20strategy%2C%20modern%20office%20workspace%2C%20corporate%20environment%2C%20high%20quality%20photography&width=600&height=400&seq=gallery1b&orientation=landscape',
        'https://readdy.ai/api/search-image?query=business%20growth%20charts%20and%20analytics%20on%20digital%20screens%2C%20clean%20modern%20background%2C%20professional%20corporate%20setting%2C%20high%20quality%20photography&width=600&height=400&seq=gallery1c&orientation=landscape'
      ]
    },
    '2': {
      title: 'نظام إدارة موارد بشرية',
      client: 'مؤسسة الخدمات الكبرى',
      category: 'حلول تقنية',
      duration: '8 أشهر',
      year: '2024',
      image: 'https://readdy.ai/api/search-image?query=modern%20HR%20management%20system%20interface%20on%20computer%20screens%20with%20professional%20workspace%2C%20clean%20minimalist%20background%2C%20corporate%20technology%20environment%2C%20high%20quality%20photography&width=1200&height=600&seq=portfoliodetail2&orientation=landscape',
      challenge: 'كانت المؤسسة تعتمد على أنظمة يدوية وورقية لإدارة الموارد البشرية، مما يسبب بطء في العمليات وأخطاء متكررة.',
      solution: 'طورنا نظاماً متكاملاً لإدارة الموارد البشرية يشمل إدارة الموظفين، الرواتب، الإجازات، التقييمات، والتدريب. النظام سهل الاستخدام ويوفر تقارير تحليلية متقدمة.',
      results: [
        { metric: 'توفير الوقت', value: '30%', description: 'تقليل الوقت المستغرق في العمليات' },
        { metric: 'رضا الموظفين', value: '85%', description: 'تحسين رضا الموظفين' },
        { metric: 'أتمتة العمليات', value: '80%', description: 'نسبة العمليات المؤتمتة' },
        { metric: 'دقة البيانات', value: '99%', description: 'تحسين دقة البيانات' }
      ],
      testimonial: {
        text: 'النظام الجديد غير طريقة عملنا بالكامل. أصبحت العمليات أسرع وأكثر دقة، والموظفون سعداء بسهولة الاستخدام.',
        author: 'فاطمة الزهراني',
        position: 'مدير الموارد البشرية'
      },
      gallery: [
        'https://readdy.ai/api/search-image?query=HR%20management%20software%20interface%20with%20employee%20data%20and%20analytics%2C%20clean%20modern%20design%2C%20professional%20business%20application%2C%20high%20quality%20photography&width=600&height=400&seq=gallery2a&orientation=landscape',
        'https://readdy.ai/api/search-image?query=digital%20HR%20dashboard%20with%20performance%20metrics%20and%20reports%2C%20clean%20minimalist%20background%2C%20professional%20corporate%20technology%2C%20high%20quality%20photography&width=600&height=400&seq=gallery2b&orientation=landscape',
        'https://readdy.ai/api/search-image?query=employee%20self-service%20portal%20on%20mobile%20and%20desktop%20devices%2C%20clean%20bright%20background%2C%20modern%20HR%20technology%2C%20high%20quality%20photography&width=600&height=400&seq=gallery2c&orientation=landscape'
      ]
    },
    '3': {
      title: 'برنامج تدريب القيادات',
      client: 'مجموعة الأعمال الدولية',
      category: 'تدريب وتطوير',
      duration: '4 أشهر',
      year: '2023',
      image: 'https://readdy.ai/api/search-image?query=professional%20leadership%20training%20session%20with%20executives%20in%20modern%20conference%20room%2C%20clean%20bright%20background%2C%20corporate%20learning%20environment%2C%20high%20quality%20photography&width=1200&height=600&seq=portfoliodetail3&orientation=landscape',
      challenge: 'احتاجت المجموعة إلى تطوير مهارات القيادة لدى المديرين التنفيذيين لمواكبة التوسع السريع للشركة.',
      solution: 'صممنا برنامجاً تدريبياً شاملاً يغطي جميع جوانب القيادة الحديثة، مع ورش عمل تفاعلية، دراسات حالة، وجلسات توجيه فردية.',
      results: [
        { metric: 'المشاركون', value: '150', description: 'قائد تم تدريبهم' },
        { metric: 'تحسين الأداء', value: '40%', description: 'زيادة في الأداء القيادي' },
        { metric: 'مشاريع جديدة', value: '50', description: 'مشروع تطوير تم إطلاقه' },
        { metric: 'رضا المشاركين', value: '95%', description: 'نسبة الرضا عن البرنامج' }
      ],
      testimonial: {
        text: 'البرنامج التدريبي كان تحولياً. تعلمنا مهارات قيادية جديدة ساعدتنا في قيادة فرقنا بشكل أفضل وتحقيق نتائج استثنائية.',
        author: 'خالد المطيري',
        position: 'نائب الرئيس التنفيذي'
      },
      gallery: [
        'https://readdy.ai/api/search-image?query=leadership%20workshop%20with%20executives%20participating%20in%20group%20activities%2C%20clean%20bright%20background%2C%20professional%20training%20environment%2C%20high%20quality%20photography&width=600&height=400&seq=gallery3a&orientation=landscape',
        'https://readdy.ai/api/search-image?query=business%20leaders%20in%20interactive%20training%20session%20with%20facilitator%2C%20modern%20conference%20room%2C%20corporate%20learning%20setting%2C%20high%20quality%20photography&width=600&height=400&seq=gallery3b&orientation=landscape',
        'https://readdy.ai/api/search-image?query=executive%20coaching%20session%20one-on-one%20in%20professional%20office%2C%20clean%20minimalist%20background%2C%20corporate%20mentoring%20environment%2C%20high%20quality%20photography&width=600&height=400&seq=gallery3c&orientation=landscape'
      ]
    }
  };

  const project = projectsData[id || '1'] || projectsData['1'];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src={project.image} 
            alt={project.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-white">
            <div className="flex flex-wrap items-center gap-4 mb-6">
              <span className="bg-blue-600 px-4 py-2 rounded-lg font-semibold">{project.category}</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">{project.year}</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">{project.duration}</span>
            </div>
            <h1 className="text-5xl font-bold mb-4">{project.title}</h1>
            <p className="text-2xl text-gray-200">{project.client}</p>
          </div>
        </div>
      </section>

      {/* Project Details */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Challenge */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">التحدي</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {project.challenge}
              </p>
            </div>

            {/* Solution */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">الحل</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {project.solution}
              </p>
            </div>

            {/* Results */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-800 mb-8">النتائج</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {project.results.map((result: any, index: number) => (
                  <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 text-center">
                    <div className="text-5xl font-bold text-blue-600 mb-3">{result.value}</div>
                    <div className="text-xl font-bold text-gray-800 mb-2">{result.metric}</div>
                    <div className="text-gray-600">{result.description}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Gallery */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-800 mb-8">معرض الصور</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {project.gallery.map((image: string, index: number) => (
                  <div key={index} className="relative h-64 w-full rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`صورة ${index + 1}`}
                      className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500 cursor-pointer"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Testimonial */}
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-10 text-white mb-16">
              <div className="flex items-start gap-4 mb-6">
                <i className="ri-double-quotes-r text-5xl text-blue-300"></i>
              </div>
              <p className="text-xl leading-relaxed mb-8">
                {project.testimonial.text}
              </p>
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-user-line text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-lg">{project.testimonial.author}</div>
                  <div className="text-blue-200">{project.testimonial.position}</div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center">
              <h3 className="text-3xl font-bold text-gray-800 mb-6">هل لديك مشروع مشابه؟</h3>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                دعنا نساعدك في تحقيق نتائج مماثلة أو أفضل
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <Link 
                  to="/request-service"
                  className="inline-flex items-center gap-3 bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <span>ابدأ مشروعك</span>
                  <i className="ri-arrow-left-line"></i>
                </Link>
                <Link 
                  to="/portfolio"
                  className="inline-flex items-center gap-3 bg-gray-200 text-gray-800 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <span>عودة للمشاريع</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}